(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const bdpHeroControllers = new Map();

  function initBdpHeroVideos(root) {
    root.querySelectorAll('.hero__media-wrapper video').forEach((video) => {
      if (bdpHeroControllers.has(video)) return;
      const controller = new AbortController();
      const { signal } = controller;
      let pending = false;
      const visible = () => {
        const rect = video.getBoundingClientRect();
        return video.isConnected && !document.hidden && rect.width > 0 && rect.height > 0 &&
          rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      };
      const play = () => {
        if (!visible() || !video.paused || pending || video.error) return;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        pending = true;
        video.play().then(() => {
          delete video.dataset.bdpPlayError;
        }).catch((error) => {
          video.dataset.bdpPlayError = error.name;
        }).finally(() => { pending = false; });
      };
      video.addEventListener('loadeddata', play, { signal });
      video.addEventListener('canplay', play, { signal });
      window.addEventListener('pageshow', play, { signal });
      document.addEventListener('visibilitychange', play, { signal });
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) play();
      });
      observer.observe(video);
      bdpHeroControllers.set(video, { controller, observer });
      play();
    });
  }

  initBdpHeroVideos(document);
  document.addEventListener('shopify:section:load', (event) => initBdpHeroVideos(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [video, state] of bdpHeroControllers) {
      if (event.target.contains(video)) {
        state.controller.abort();
        state.observer.disconnect();
        bdpHeroControllers.delete(video);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
